import '../../styles/index.scss';

import { graphql } from 'gatsby';
import { PropTypes } from 'prop-types';
import React, { useRef } from 'react';

import ArticleEnd from '../../components/Article/ArticleEnd';
import ArticlePodcastHeader from '../../components/Article/ArticleHeader/ArticlePodcastHeader';
import ArticlePodcast from '../../components/Article/ArticlePodcast/ArticlePodcast';
import { podcastThemeNamesMap } from '../../components/Article/ArticlePodcast/Mappings';
import ArticleRecirculation from '../../components/Article/ArticleRecirculation';
import ArticleRender from '../../components/Article/ArticleRender';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Metadata from '../../components/Metadata';
import { getArticleHeaderTheme, toCamelCase } from '../../utils';

const PodcastTemplate = ({ data, location }) => {
  const {
    body,
    credits,
    franchise,
    header = {},
    metadata = {},
    podcastTheme,
    publishedDate,
    tags,
    title
  } = data.contentfulArticlePodcast;

  const {
    link,
    main: background,
    text: color,
  } = podcastThemeNamesMap[podcastTheme];

  const getHeader = {
    ...header,
    backgroundColor: background,
    textColor: color,
  };

  const headerTheme = getArticleHeaderTheme({
    backgroundColorName: toCamelCase(getHeader?.backgroundColor),
    textColorName: toCamelCase(getHeader?.textColor),
  });

  const breakpointRef = useRef(null);

  const fallbackMetadata = {
    title,
  };

  return (
    <>
      <Metadata
        created={publishedDate}
        data={metadata || fallbackMetadata}
        location={location}
      />
      <div>
        <Header
          backgroundColor={headerTheme.backgroundColor}
          breakpointRef={breakpointRef}
          showBorder
          textColor={headerTheme.textColor}
        />
        <ArticlePodcastHeader
          ref={breakpointRef}
          header={getHeader}
          isMinified
          podcastTheme={podcastTheme}
        />
        <ArticlePodcast color={link} podcast={data.contentfulArticlePodcast} />
        <div className="article" data-module-id="podcast_template" id="article">
          {body &&
            body.map((item) =>
              ArticleRender(
                item,
                {
                  backgroundColor: background,
                  textColor: color,
                },
                false,
              ),
            )}
          <ArticleEnd credits={credits} pageLocation={location} tags={tags} />
        </div>
        <ArticleRecirculation
          articleFranchise={franchise}
          articleTags={tags}
          articleTitle={header && header.title}
          data={data}
        />
      </div>
      <Footer />
    </>
  );
};

PodcastTemplate.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
};

export const query = graphql`
  query ($slug: String, $tags: [String] = [], $franchise: String) {
    contentfulArticlePodcast(slug: { eq: $slug }) {
      
      title
      slug
      tags {
        name
        slug
        type
      }
      franchise {
        franchiseName
      }
      audio {
        file {
          contentType
          url
        }
      }
      podcastLinks {
        title
        url
        icon {
          ...ContentfulSvgImageFragment
        }
      }
      credits {
        ... on ContentfulCredits {
          name
          slug
          type
        }
      }
      publishedDate
      header {
        title
        headline
        backgroundColor
        textColor
      }
      podcastTheme
      body {
        ...ContentfulAllArticleComponentsFragment
      }
      metadata {
        ...ContentfulMetadataFragment
      }
    }
    ...ArticleRecirculationFragment
  }
`;

export default PodcastTemplate;
